import { validCookieId, getHeaders } from '/source/js/utils/validCookie';

const CHECKOUT_SESSION_API = '/sitecore/api/ssc/rw/isagenix/checkoutapi';
const CHECKOUT_SESSION_READ_API = '/sitecore/api/ssc/ro/isagenix/checkoutapi';

export async function getShippingOptions(data) {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_READ_API}/getshippingoptions`,
        data: data
    });
    return validCookieId(result);
}

export async function getStateProvinceList(countryCode, itemId) {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_API}/getstateprovincelanguagelist`,
        data: { CountryCode: countryCode, CountryItemId: itemId }
    });
    return validCookieId(result);
}

export async function getMelissaAddress(data) {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_API}/getmelissaaddress`,
        data: data
    });
    return validCookieId(result);
}

export async function getPaymetricParameters() {
    return $.ajax({
        headers: getHeaders(),
        type: 'GET',
        url: `${CHECKOUT_SESSION_API}/getpaymetricparameters`
    });
}

export async function getPaymetricParametersModernized() {
    return $.ajax({
        headers: getHeaders(),
        type: 'GET',
        url: `${CHECKOUT_SESSION_API}/getpaymetricparametersmodernized`
    });
}

export async function getBraintreeToken(isSubscription) {
    return $.ajax({
        headers: getHeaders(),
        type: 'GET',
        url: `${CHECKOUT_SESSION_API}/getBraintreeToken?autoshipToken=${isSubscription}`
    });
}

export async function getPaymentDetails() {
    return $.ajax({
        headers: getHeaders(),
        type: 'GET',
        url: `${CHECKOUT_SESSION_API}/getpaymentcarddetails`
    });
}

export async function cancelSubscription() {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_API}/discardsubscription`
    });
    return validCookieId(result);
}

export async function cancelSetUpSubscription() {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_API}/cancelsetupsubscription`
    });
    return validCookieId(result);
}

export async function discardChanges() {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_API}/discardchanges`
    });
    return validCookieId(result);
}

export async function confirmPaymentChanges(data) {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_API}/confirmpaymentchanges`,
        data: data
    });
    return validCookieId(result);
}

export async function saveChanges(data) {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_API}/savechanges`,
        data: data
    });
    return validCookieId(result);
}

export async function getCheckoutShippingViewModel() {
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
        type: 'GET',
        url: `${CHECKOUT_SESSION_API}/getCheckoutShippingViewModel`
    });
}

export async function setShippingMethodForApplepay(request) {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_READ_API}/setShippingMethodForApplepay`,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(request)
    });
    return validCookieId(result);
}

export async function getShippingOptionsForApplepay(data) {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_READ_API}/getShippingOptionsForApplepay`,
        data: data
    });
    return validCookieId(result);
}

export async function processApplepay(request) {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_READ_API}/ProcessApplepay`,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(request)
    });
    return validCookieId(result);
}

export async function getAddressByPostalCode(data) {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_API}/getAddressByPostalCode`,
        data: data
    });
    return validCookieId(result);
}

export async function checkIfPhoneNumberIsUnique(data) {
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
        type: 'POST',
        url: `${CHECKOUT_SESSION_READ_API}/checkIfPhoneNumberIsUnique`,
        data: data
    });
}

export async function validatePhone(data) {
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
        type: 'POST',
        url: `${CHECKOUT_SESSION_READ_API}/RequestVerificationCode`,
        data: data
    });
}

export async function verifyCode(data) {
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
        type: 'POST',
        url: `${CHECKOUT_SESSION_READ_API}/ValidateVerificationCode`,
        data: data
    });
}

export async function ValidateIban(data) {
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
        type: 'POST',
        url: `${CHECKOUT_SESSION_READ_API}/ValidateIban`,
        data: data
    });
}

export async function processBancontact(request) {
    const result = $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_READ_API}/ProcessBancontact`,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(request)
    });
    return validCookieId(result);
}

export async function updatePaymentPending(request) {
    return $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_READ_API}/UpdatePaymentPending`,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(request)
    });
}

export async function getBillingAddressView(data) {
    return $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_READ_API}/GetBillingAddressView`,
        data: data
    });
}

export async function convertMembertoBP() {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_READ_API}/ConvertMembertoBP`
    });
    return result;
}

export async function setCreditCardPaymentDetails(request) {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_API}/SetCreditCardPaymentDetails`,
        data: request
    });
    return validCookieId(result);
}

export async function ValidUsername(data) {
    const result = $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_API}/CheckoutEnrollValidateUsername`,
        data: data
    });
    return result;
}

export async function getGoogleAnalyticsDetails(request) {
    return $.ajax({
        type: 'GET',
        url: `${CHECKOUT_SESSION_API}/GetGoogleAnalyticsDetails`,
        headers: getHeaders(),
        contentType: 'application/json',
        dataType: 'json',
        data: request
    });
}

export async function setHowDidYouFindUsDetails(request) {
    return $.ajax({
        url: `${CHECKOUT_SESSION_API}/SetHowDidYouFindUsDetails`,
        type: 'POST',
        headers: getHeaders(),
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        dataType: 'json',
        data: request
    });
}

export async function getHowDidYouFindUsDetails(request) {
    return $.ajax({
        type: 'GET',
        url: `${CHECKOUT_SESSION_API}/GetHowDidYouFindUsDetails`,
        headers: getHeaders(),
        contentType: 'application/json',
        dataType: 'json',
        data: request
    });
}

export async function getMelissaExpressAddressMatches(requestData) {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CHECKOUT_SESSION_API}/getmelissaexpressaddressmatches`,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(requestData)
    });
    return validCookieId(result);
}
